import React from 'react'
import styles from './ScoutOfferPattern.module.css'
import { ScoutOfferPatternProps } from './types'
import { useAbTestGtm } from '@/components/utils/abTest'
import { CtaButton } from './CtaButton'

const IMAGE_DIR = '/pages/abtest/dev3392'

// DEV-3392 Dパターン: 期限の代わりに実績訴求で「登録する理由」をつける。
// オファー終了日時は出さないデザインのため expiredDate は使わない。
export const ScoutOfferD = ({ telImageSrc, upgradeUrl }: ScoutOfferPatternProps) => {
    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.body}>
            <img
                src={`${IMAGE_DIR}/d_head.png`}
                alt='ご登録ありがとうございます！今すぐ転職を考えていない場合は、ご相談だけでも歓迎！'
                className={styles.strip}
            />
            <div className={styles.telRowCD}>
                <img src={telImageSrc} alt='TEL画像' className={styles.telImage} />
            </div>
            <div data-view-label={dataViewLabel('Thanks_CT_スカウト')}>
                <div data-view-label={dataViewLabel('Thanks_CT_スカウト_コンテンツ1')}>
                    <img
                        src={`${IMAGE_DIR}/d_top.png`}
                        alt='せっかくなので、スカウト機能も試してみませんか？フーズラボで転職した人の約4人に1人がスカウトで転職成功'
                        className={styles.strip}
                    />
                </div>
                <CtaButton
                    bgSrc={`${IMAGE_DIR}/d_cta1_bg.png`}
                    bgWidth={750}
                    bgHeight={220}
                    button={{ x: 75, y: 58, w: 600, h: 104 }}
                    shape='pill'
                    text='スカウトを受け取る'
                    href={upgradeUrl}
                    dataClickLabel={dataClickLabel('Thanks_CT_スカウト_CTAボタン1')}
                    badge={{ box: { x: 129, y: 9, w: 490, h: 62 }, text: '今なら企業の目に留まりやすい！' }}
                />
                <img
                    src={`${IMAGE_DIR}/d_benefit.png`}
                    alt='スカウト転職の魅力'
                    className={styles.strip}
                />
                <div data-view-label={dataViewLabel('Thanks_CT_スカウト_コンテンツ2')}>
                    <img
                        src={`${IMAGE_DIR}/d_upgrade.png`}
                        alt='アップグレードするには？所要時間2分、次のページで基本情報や職歴を登録するだけ！'
                        className={styles.strip}
                    />
                </div>
                <CtaButton
                    bgSrc={`${IMAGE_DIR}/d_cta2_bg.png`}
                    bgWidth={750}
                    bgHeight={178}
                    button={{ x: 75, y: 66, w: 600, h: 104 }}
                    shape='pill'
                    text='スカウトを受け取る'
                    href={upgradeUrl}
                    dataClickLabel={dataClickLabel('Thanks_CT_スカウト_CTAボタン2')}
                    badge={{ box: { x: 129, y: 17, w: 490, h: 62 }, text: '今なら企業の目に留まりやすい！' }}
                />
                <img src={`${IMAGE_DIR}/d_tail.png`} alt='' className={styles.strip} />
            </div>
        </div>
    )
}

export default ScoutOfferD
